const brochure = {
  'brochure.jsonld.breadcrumb1': 'Home',
  'brochure.jsonld.breadcrumb2': 'Contact',
  'brochure.jsonld.breadcrumb3': 'Brochure Request',
  'brochure.jsonld.orgName': 'The Japan Butler Academy',
  'brochure.jsonld.parentOrg': 'The All Japan Butler Association',
  'brochure.page.homeLink': 'Home',
  'brochure.page.contactLink': 'Contact',
  'brochure.page.currentPage': 'Brochure Request',
  'brochure.page.lastUpdated': 'Last updated: 13 June 2026',
  'brochure.page.backToTop': 'Back to top',

  'brochure.hero.homeLink': 'Home',
  'brochure.hero.contactLink': 'Contact',
  'brochure.hero.currentPage': 'Brochure Request',
  'brochure.hero.title': 'Request a Brochure',
  'brochure.hero.titleEn': 'BROCHURE',
  'brochure.hero.lead': 'Download or receive a free printed brochure covering our courses, fees, curriculum, and the story behind The Japan Butler Academy.',
  'brochure.hero.imgAlt': 'A butler standing in the academy library, holding programme documents',

  'brochure.contents.label': 'CONTENTS',
  'brochure.contents.title': 'What\'s Inside the Brochure',
  'brochure.contents.subtitleEn': 'What\'s Inside',
  'brochure.contents.lead': 'Everything you need to decide whether The Japan Butler Academy is right for you, presented clearly in one document.',
  'brochure.contents.0.title': 'Academy Overview',
  'brochure.contents.0.titleEn': 'Academy Overview',
  'brochure.contents.0.desc': 'The history and mission of The Japan Butler Academy, its educational philosophy, and how it is run.',
  'brochure.contents.1.title': 'All Three Courses & Fees',
  'brochure.contents.1.titleEn': 'Courses & Pricing',
  'brochure.contents.1.desc': 'A full breakdown of the Essential, Advanced, and Master courses — including curriculum content and tuition fees.',
  'brochure.contents.2.title': 'Curriculum & Annual Schedule',
  'brochure.contents.2.titleEn': 'Curriculum & Schedule',
  'brochure.contents.2.desc': 'An overview of the learning journey, daily timetable, and the full annual class schedule.',
  'brochure.contents.3.title': 'Certification & Award',
  'brochure.contents.3.titleEn': 'Certification',
  'brochure.contents.3.desc': 'Details of the association-recognised certificate awarded on completion and how it can advance your career.',
  'brochure.contents.4.title': 'How to Apply',
  'brochure.contents.4.titleEn': 'Application Process',
  'brochure.contents.4.desc': 'Eligibility requirements and a step-by-step guide from enquiry to enrolment.',
  'brochure.contents.notice': 'Brochure contents are subject to change without prior notice. Please refer to this website for the most up-to-date information. Printed copies sent by post may take several days to arrive.',

  'brochure.form.label': 'REQUEST FORM',
  'brochure.form.title': 'Brochure Request Form',
  'brochure.form.subtitleEn': 'Brochure Request Form',
  'brochure.form.lead': 'Please complete the form below. Your details will be used solely to send you the requested brochure.',
  'brochure.form.required': 'Required',
  'brochure.form.optional': 'Optional',
  'brochure.form.name': 'Full Name',
  'brochure.form.namePlaceholder': 'e.g. Taro Shitsuji',
  'brochure.form.nameError': 'Full name is required',
  'brochure.form.furigana': 'Furigana (reading)',
  'brochure.form.furiganaPlaceholder': 'e.g. shitsuji taro',
  'brochure.form.furiganaError': 'Furigana is required',
  'brochure.form.email': 'Email Address',
  'brochure.form.emailPlaceholder': 'e.g. taro@example.com',
  'brochure.form.emailError': 'Email address is required',
  'brochure.form.emailInvalidError': 'Please enter a valid email address',
  'brochure.form.phone': 'Phone Number',
  'brochure.form.phonePlaceholder': 'e.g. 090-1234-5678',
  'brochure.form.delivery': 'Delivery Method',
  'brochure.form.delivery.pdf': 'PDF by email',
  'brochure.form.delivery.pdf.desc': 'A PDF of the brochure will be sent to the email address you provide. Available immediately.',
  'brochure.form.course': 'Course of Interest',
  'brochure.form.course.essential': 'Essential Course',
  'brochure.form.course.advanced': 'Advanced Course',
  'brochure.form.course.master': 'Master Course',
  'brochure.form.course.undecided': 'Not yet decided',
  'brochure.form.privacy': 'Privacy Policy',
  'brochure.form.privacyAgree': 'I agree to the',
  'brochure.form.privacyError': 'You must agree to the Privacy Policy to proceed',
  'brochure.form.noHardSell': 'Brochure requests are free. We will not contact you beyond your stated interests. Please feel free to apply.',
  'brochure.form.submit': 'Request Brochure',

  'brochure.post.label': 'AFTER SUBMISSION',
  'brochure.post.title': 'What Happens Next',
  'brochure.post.subtitleEn': 'What Happens Next',
  'brochure.post.lead': 'PDF requests are fulfilled promptly. Printed copies are sent by post and typically arrive within a few days.',
  'brochure.post.step1.title': 'Automatic Confirmation Email',
  'brochure.post.step1.desc': 'An automated acknowledgement will be sent to the email address you provided.',
  'brochure.post.step2.title': 'Brochure Delivered',
  'brochure.post.step2.desc': 'PDF requests are sent within one business day. Printed copies are dispatched by post and arrive within a few days.',
  'brochure.post.step3.title': 'Consultation Available on Request',
  'brochure.post.step3.desc': 'If you would like to discuss the courses further, a free one-to-one consultation is also available.',

  'brochure.alt.label': 'ALTERNATIVE',
  'brochure.alt.title': 'Request by Phone or Email',
  'brochure.alt.subtitleEn': 'Other Request Methods',
  'brochure.alt.lead': 'You are also welcome to request a brochure by telephone or email.',
  'brochure.alt.phoneHours': 'Weekdays 10:00–17:00 JST',
  'brochure.alt.emailReply': 'Reply within 1 business day',

  'brochure.cta.label': 'NEXT STEP',
  'brochure.cta.title': 'Free Consultation Also Available',
  'brochure.cta.subtitleEn': 'Take the Next Step',
  'brochure.cta.lead': 'After reading the brochure, you are welcome to book a free consultation to ask any remaining questions.',
  'brochure.cta.btn': 'Book a Free Consultation',

  'brochure.pdfDl.button': 'After you submit your request, we will email you a link to download the guide.',

  'brochure.faq.label': 'FAQ',
  'brochure.faq.title': 'Frequently Asked Questions',
  'brochure.faq.subtitleEn': 'Frequently Asked Questions',
  'brochure.faq.0.q': 'Is the brochure free?',
  'brochure.faq.0.a': 'Yes, completely free. We send a PDF by email as standard, or a printed copy by post on request.',
  'brochure.faq.1.q': 'What is in the brochure?',
  'brochure.faq.1.a': 'The brochure covers the academy overview, all three courses and their fees, the full curriculum, our certification, the annual schedule, and how to apply.',
  'brochure.faq.2.q': 'Will I receive promotional calls or emails?',
  'brochure.faq.2.a': 'We do not send unsolicited follow-up communications. If you would like to speak with an adviser, we will reach out only at your request.',

  'brochure.related.label': 'LEARN MORE',
  'brochure.related.title': 'Related Pages',
  'brochure.related.subtitleEn': 'Explore Further',
  'brochure.related.viewMore': 'Learn More',
  'brochure.related.0.title': 'Book a Consultation',
  'brochure.related.0.description': 'Free — also available online',
  'brochure.related.1.title': 'Courses Overview',
  'brochure.related.1.description': 'Compare all three courses at a glance',
  'brochure.related.2.title': 'Taster Session',
  'brochure.related.2.description': 'Experience butler training in one day',
  'brochure.related.3.title': 'Contact',
  'brochure.related.3.description': 'Questions and enquiries',
};

export default brochure;
